import IsOrNotOperationSelect from 'components/UnifiedCampaignForm/TargetingForm/SegmentationCriteria/CriteriaInputs/IsOrNotOperationSelect';
import React from 'react';
import ImprovedSuggester from 'components/library/Input/Suggester/ImprovedSuggester';
import { i18n } from 'utils/translate';

function AgencyNameCriteriaSuggesterText({
    value,
    operation,
    field,
    onChangeCriteriaOperation,
    onChangeAgencyValue,
    agencySuggesterOptions,
    isAgencySuggesterLoading,
    onChangeCriteriaValue,
    operationSelectLabels,
}) {
    return (
        <>
            <IsOrNotOperationSelect
                operation={operation}
                onChange={(event) =>
                    onChangeCriteriaOperation(field, event.target.value)
                }
                labels={operationSelectLabels}
            />
            <div className="targeting__criteria-value">
                <ImprovedSuggester
                    value={value}
                    options={agencySuggesterOptions}
                    id={`${field}-selector`}
                    label=""
                    debounceDelay={600}
                    loading={isAgencySuggesterLoading}
                    noOptionsText={i18n('partners_no_results')}
                    loadingText={i18n('js_loading_data')}
                    onFocus={
                        agencySuggesterOptions == null
                            ? () => onChangeAgencyValue(field, '')
                            : () => {}
                    }
                    onChange={(event) =>
                        onChangeAgencyValue(field, event.target.value)
                    }
                    onSelect={(_, selectedValues) =>
                        onChangeCriteriaValue(field, selectedValues)
                    }
                    required
                />
            </div>
        </>
    );
}

export default AgencyNameCriteriaSuggesterText;
